import { useEffect, useState } from "preact/hooks";

export function useAsync(asyncFn, deps = []) {
  const [state, setState] = useState({
    status: "loading",
    data: null,
    error: null,
  });

  useEffect(() => {
    const controller = new AbortController();
    setState({ status: "loading", data: null, error: null });

    asyncFn({ signal: controller.signal })
      .then((data) =>
        setState({ status: "loaded", data, error: null }),
      )
      .catch((error) => {
        if (error.name === "AbortError") return;
        console.error("useAsync error", error);
        setState({ status: "error", data: null, error });
      });

    return () => controller.abort();
  }, deps);

  return state;
}
